import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';

// services
import { AppService } from '@base/app.service';
import { TableauService } from '@tableau/tableau.service';
import { environment } from '@environments/environment';

// store
import { WorkbookState } from '@workbook/store/workbook.reducer';
import * as WorkbookActions from '@workbook/store/workbook.actions';
import * as WorkbookSelectors from '@workbook/store/workbook.selectors';

import * as fromModels from '@models';
import * as fromUtils from '@utils';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { ViewService } from '@base/view/view.service';
import { takeUntil } from 'rxjs/operators';
import { AngularFireStorage } from 'angularfire2/storage';
import { WorkbookService } from '@workbook/workbook.service';
import { HttpErrorResponse } from '@angular/common/http';
import { IWorkbooklog, IUser, User, IWorkbook, Workbook } from '@interfaces';

const BUCKET = environment.buckets;


@Component({
  selector: 'app-tableau-image',
  templateUrl: './tableau-image.component.html',
  styleUrls: ['./tableau-image.component.sass']
})
export class TableauImageComponent implements OnInit, OnDestroy {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  private workbookId: number;
  private currentUser: fromModels.User = null;
  workbook: Observable<fromModels.Workbook>;
  hasSnapshot = false;
  snapshotUrl = null;

  constructor(
    private workBookService: WorkbookService,
    private router: Router,
    private mainService: AppService,
    private snackBar: MatSnackBar,
    private tableauService: TableauService,
    private viewService: ViewService,
    private route: ActivatedRoute,
    private store: Store<{roles: WorkbookState}>,
    private fireStorage: AngularFireStorage,
  ) {
    this.workbookId = fromUtils.getNumber(this.route.snapshot.paramMap.get('id'));

    if (this.workbookId > 0 ) {
      this.store.dispatch(WorkbookActions.getWorkbook({workbookId: this.workbookId}));
    } else {
      const toastObject = new fromModels.SnackBar({message: 'La imagen del Reporte no fue generada'});
      this.showSnapshotFailMessage(toastObject);
    }

    this.mainService.getCurrentUser().subscribe(
      (user) => {
        const u = new fromModels.User(user);
        this.currentUser = u;
    });

    this.tableauService.setNavBackButtonStatus(true);
    this.tableauService.setDisplayTagsStatus(false);
  }

  ngOnInit() {
    this.store.select(WorkbookSelectors.getRow)
    .pipe(takeUntil(this.destroy$))
    .subscribe(w => this.getViewSnapshot(w)
    );
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  openSnackBar(params: fromModels.SnackBar) {
    this.snackBar.open(params.message, params.title, params.config);
  }

  private showSnapshotFailMessage(toastObject: fromModels.SnackBar) {
    this.snackBar.open(toastObject.message, toastObject.title, toastObject.config)
    .afterDismissed()
    .subscribe(
      () => this.router.navigate(['home/panels/tableau'])
    );
  }

  private getViewSnapshot(wb: fromModels.Workbook) {
    const toastObject = new fromModels.SnackBar({message: 'La imagen del Reporte no fue generada'});
    if (wb === null) {
      return false;
    }

    if (wb.open_as !== fromUtils.OpenWorkbookAs.Image) {
      toastObject.message = 'El reporte no esta configurado para abrir como Imagen';
      console.log(toastObject.message);
      this.showSnapshotFailMessage(toastObject);
    }

    const view = wb.views.find(v => v.default_view === true);
    if (typeof view === 'undefined') {
      toastObject.message = 'El reporte no tiene Vista Inicial seteada.';
      console.log(toastObject.message);
      this.showSnapshotFailMessage(toastObject);
    }

    const emailLoginAs = (this.currentUser !== null) ? this.currentUser.email : null;
    this.viewService.getViewSnapshot(view.id, emailLoginAs).subscribe(response => {
      const snapshotName = response['snapshot_name'];
      this.hasSnapshot = response['uploaded'];

      if (this.hasSnapshot) {
        const uri = `${BUCKET.snapshots}${wb.company['slug']}/${snapshotName}`;
        this.fireStorage.ref(uri).getDownloadURL().subscribe(
          (uriSnapshot) => {
            const userLog: IUser = new User();
            const workbookLog = new Workbook();
            userLog.id = this.currentUser.id;
            workbookLog.id = wb.id;
            const payload: IWorkbooklog = {
              user: userLog,
              workbook: workbookLog,
            };
            this.workBookService.registerLog(payload).subscribe(
              (log: IWorkbooklog) => {},
              (err: HttpErrorResponse) => console.log(err.message)
            );

            this.snapshotUrl = uriSnapshot;
          },
          () => this.showSnapshotFailMessage(toastObject)
        );
      } else {
        this.showSnapshotFailMessage(toastObject);
      }
    });
  }
}
